<template>
  <div v-if="!consumerFriendlyMode" class="w-full">
    <section class="section">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-6 large-4"></div>

        <div class="cell medium-6 large-4 large-offset-4">
          <collapse
            icon-active="indeterminate_check_box"
            icon-inactive="add_box"
            icon-position="left"
            align-icon="start"
            icon-classes="md-18"
            :default-active="false"
          >
            <collapse-item v-if="list.bikesEntries && list.bikesEntries.length > 0" name="saved-list-summary.bikes">
              <template slot="title">
                <div class="flex flex-wrap w-full">
                  <div class="flex justify-between w-full" qaid="saved-list-bikes-title">
                    <span class="font-medium"> {{ bp('bikes') }} ({{ list.bikesEntries.length }}) </span>
                    <span>{{ list.bikesTotal }}</span>
                  </div>
                </div>
              </template>

              <div v-cloak class="block-list">
                <div class="block-list__item w-full" qa="saved-list-bikes-subtotal">
                  <span>{{ bp('bikesSubtotal') }}</span>
                  <span>{{ list.bikesSubtotal }}</span>
                </div>
                <div class="block-list__item w-full" qa="saved-list-bikes-promotions">
                  <span>{{ bp('promotionsSubtotal') }}</span>
                  <span class="text-alert">{{ list.bikesPromotionSubTotal }}</span>
                </div>
                <div class="block-list__item w-full" qa="saved-list-bikes-total">
                  <span class="font-medium">{{ bp('bikesTotal') }}</span>
                  <span>{{ list.bikesTotal }}</span>
                </div>
              </div>
            </collapse-item>

            <collapse-item
              v-if="list.partsEntries && list.partsEntries.length > 0"
              name="saved-list-summary.accessories"
            >
              <template slot="title">
                <div class="flex flex-wrap w-full">
                  <div class="flex justify-between w-full" qaid="saved-list-accessories-title">
                    <span class="font-medium">
                      {{ bp('accessories') }}
                    </span>
                    <span>{{ list.aftermarketsTotal }}</span>
                  </div>
                </div>
              </template>

              <div v-cloak class="block-list">
                <div class="block-list__item w-full" qa="saved-list-accessories-subtotal">
                  <span>{{ bp('accessoriesSubtotal') }}</span>
                  <span>{{ list.aftermarketsSubtotal }}</span>
                </div>
                <div class="block-list__item w-full" qa="saved-list-accessories-promotions">
                  <span>{{ bp('promotionsSubtotal') }}</span>
                  <span class="text-alert">{{ list.aftermarketsPromotionSubTotal }}</span>
                </div>
                <div class="block-list__item w-full" qa="saved-list-accessories-total">
                  <span class="font-medium">{{ bp('accessoriesTotal') }}</span>
                  <span>{{ list.aftermarketsTotal }}</span>
                </div>
              </div>
            </collapse-item>
          </collapse>

          <div class="flex justify-between text-lg py-2" qa="cart-total">
            <span class="font-medium">{{ bp('subtotal') }}</span>
            <span>{{ list.subtotal }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';

export default {
  name: 'SavedListSummary',
  components: {Collapse, CollapseItem},
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },
};
</script>
